<template>
	<dms-wrapper :show-label="false" v-bind="{wrapp, span, validationRules, noLabelAlign}" :validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-radio :label="radioLabelCmp" :value="value" :disabled="isDisabled" :class="{'frm-group-checkbox': !oneLine}" :data-cy="labelKey"
			@change="$emit('update:value', radioLabelCmp)">
			{{ labelText }}
		</el-radio>
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsRadio',
	components: { DmsWrapper },
	props: {
		radioLabel: { type: [Number, String, Boolean] },
		value: { type: [Object, Number, String, Boolean] },
		oneLine: { type: Boolean, default: false },
		noLabelAlign: { type: Boolean, default: false },
	},
	computed: {
		radioLabelCmp() {
			return this.radioLabel === null ? this.labelKey || 0 : this.radioLabel;
		},
	},
});
</script>
